<template>
	<v-skeleton-loader v-if="loading" v-bind="loader" width="100%" type="card"></v-skeleton-loader>
	<v-form
		v-else
		class="notifications-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<v-row>
			<v-col cols="12" class="pt-0">
				<v-card-title class="notifications-form__title pl-0 pt-0"
					>Setting up email notifications</v-card-title
				>
				<div>
					<div class="d-flex justify-space-between align-center mb-8">
						<v-subheader class="notifications-form__description pl-0"
							>Personal selections</v-subheader
						>
						<CustomSwitch
							id="Personal selections"
							v-model="fields.personal_selections"
							:error-messages="field_errors.personal_selections"
						/>
					</div>
					<div class="d-flex justify-space-between align-center mb-8">
						<v-subheader class="notifications-form__description pl-0"
							>Posts</v-subheader
						>
						<CustomSwitch
							id="Posts"
							v-model="fields.posts"
							:error-messages="field_errors.posts"
						/>
					</div>
					<div class="d-flex justify-space-between align-center">
						<v-subheader class="notifications-form__description pl-0"
							>Sales</v-subheader
						>
						<CustomSwitch
							id="Sales"
							v-model="fields.sales"
							:error-messages="field_errors.sales"
						/>
					</div>
				</div>
			</v-col>
		</v-row>
		<v-divider class="notifications-form__divider mt-8 mb-8"></v-divider>
		<p v-for="error in errors" :key="error" class="text-danger">
			{{ error }}
		</p>
		<v-btn
			class="d-flex rounded-pill text-capitalize notifications-form__button"
			@click="validateAndSubmit"
			:loading="loading"
			>Change
		</v-btn>
	</v-form>
</template>

<script>
import { mapActions } from 'vuex'

import CustomSwitch from '@/components/CustomSwitch'
import Form from '@/mixins/Form'

export default {
	name: 'NotificationsForm',
	mixins: [Form],
	components: {
		CustomSwitch,
	},
	props: {
		settings: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			fields: {
				posts: false,
				sales: false,
				personal_selections: false,
			},
			loader: {
				class: 'mb-6',
				boilerplate: true,
				elevation: 2,
			},
		}
	},
	methods: {
		...mapActions('settings', ['setNotifications']),
		submitForm() {
			this.field_errors = {}
			return this.setNotifications(this.fields)
		},
	},
	created() {
		this.fields = this.settings
	},
}
</script>

<style lang="scss">
.notifications-form {
	&__title {
		font-style: normal;
		font-weight: bold;
		font-size: 20px;
		line-height: 67px;
		color: #202232;
	}

	&__description {
		font-style: normal;
		font-weight: 500;
		font-size: 22px;
		line-height: 67px;
		color: #cbcbcb !important;
	}

	&__button {
		height: 30px !important;
		width: 108px !important;
		border: 1px solid #4d536e;
		font-style: normal !important;
		font-weight: 600;
		font-size: 15px;
		line-height: 18px;
		background-color: white !important;
		box-shadow: none;
		text-align: center;
		letter-spacing: -0.28px;

		&:hover {
			color: #fff !important;
			background: #4d536e !important;
		}
	}

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}
</style>
